// src/data/questions.js
const questions = [
  {
    id: "q1",
    text: ``,
    marks: 11,
    summary: "Computational thinking",
    initialCode: ``,
    prompt: ``,
    parts:[
      
      
      {
      id: "1.1",
      text: `A software development team is creating a mobile fitness app that tracks users' daily exercise routines. The app includes various functions to record workouts, display statistics, and generate progress reports.
      (a) The team created a function called generateReport() that handles all the complex calculations and data processing but presents users with a simple, easy-to-read summary. What computational thinking technique is being used to hide these internal complexities?`,
      marks: 1,
      summary: "Computational thinking",
      initialCode: ``,
      prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
              Question: A software development team is creating a mobile fitness app that tracks users' daily exercise routines. The app includes various functions to record workouts, display statistics, and generate progress reports.

              a) The team created a function called generateReport() that handles all the complex calculations and data processing but presents users with a simple, easy-to-read summary. What computational thinking technique is being used to hide these internal complexities? [1 mark]

              Marks: 1 mark total

              Marking Instructions:
              Award 1 mark for the correct answer:
              - Abstraction

              Final Scoring:
              Total marks: 1 mark for identifying abstraction as the computational thinking technique

              Explanation to Student: Provide feedback on whether the answer is correct. If incorrect, explain that abstraction is the computational thinking technique used to hide internal complexities while presenting a simpler interface to users.

              **Student Response:**`
    },{
      id: "1.2",
      text: `(b) Sarah is developing a music playlist app where users can search for songs by title. The songs aren't automatically alphabetised when added to the playlist. She needs to implement a search function that works with this unsorted list of songs.
      (i) Explain how a linear search algorithm would work in Sarah's app to find a specific song title in the unsorted playlist.`,
      marks: 4,
      summary: "Computational thinking",
      initialCode: ``,
      prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
              Question:
              Sarah is developing a music playlist app where users can search for songs by title. The songs aren't automatically alphabetized when added to the playlist. She needs to implement a search function that works with this unsorted list of songs. Explain how a linear search algorithm would work in Sarah's app to find a specific song title in the unsorted playlist.
              Marks: 4 marks total

              1 mark for explaining starting at the beginning of the playlist
              1 mark for explaining the comparison of each song title
              1 mark for explaining when to stop if the song is found
              1 mark for explaining the continuation to the end if not found

              Marking Instructions:

              Award marks for each correctly explained component of linear search
              Check that the explanation is specific to searching song titles
              Ensure the sequence of steps is logical
              All key aspects must be clearly explained for full marks

              Final Scoring:
              Starting Point: 1 mark
              Comparison Process: 1 mark
              Found Condition: 1 mark
              Not Found Process: 1 mark
              Explanation to Student:
              Provide feedback on the student's explanation, highlighting correct points and explaining any missing or incorrect information.
              **Student Response:**`
    },{
      id: "1.3",
      text: `(c) A startup company is developing an educational virtual reality (VR) space exploration game. Players navigate a spacecraft through an asteroid field using hand controllers. When they successfully reach the space station without colliding with asteroids, celebratory music plays and their mission score is displayed.
      (i) Discuss how decomposition and abstraction are utilized in developing this VR space game. 
      Your answer should include:
      •  A definition of each term
      •  The benefits each brings to the development team
      •  An example of where each could appear in the program code`,
      marks: 6,
      summary: "Computational thinking",
      initialCode: ``,
      prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
    Question: A startup company is developing an educational virtual reality (VR) space exploration game. Players navigate a spacecraft through an asteroid field using hand controllers. When they successfully reach the space station without colliding with asteroids, celebratory music plays and their mission score is displayed.

Discuss how decomposition and abstraction are utilized in developing this VR space game. Your answer should include:
- A definition of each term
- The benefits each brings to the development team
- An example of where each could appear in the program code
[6 marks]

Marks: 6 marks total

Marking Instructions:

Level 3 (5-6 marks):
- Clear and accurate definitions of both decomposition and abstraction in the context of VR game development
- Thorough explanation of benefits for both techniques to the development team
- Relevant and specific code examples for both techniques
- Coherent, well-structured answer showing comprehensive understanding

Level 2 (3-4 marks):
- Basic but correct definitions of both techniques
- Some explanation of benefits to the team
- At least one relevant code example
- Answer shows reasonable understanding but may lack detail

Level 1 (1-2 marks):
- Limited or unclear definitions
- Few or no benefits discussed
- No clear code examples
- Basic response showing minimal understanding

Level 0 (0 marks):
- No creditworthy material

Indicative Content:
Decomposition:
- Breaking down complex game systems into smaller components
- Examples: collision detection, score calculation, sound management
- Code examples: updateAsteroidPosition(), checkCollision()
- Benefits: easier team collaboration, simpler testing, maintainable code

Abstraction:
- Hiding implementation details behind simple interfaces
- Examples: VR controller input handling, physics simulation, particle effects
- Code examples: handleControllerInput(), updatePhysics()
- Benefits: reduced complexity, modular development, easier debugging

Final Scoring:
Award marks based on the level descriptors above, considering completeness and accuracy of all three required elements.

Explanation to Student: Provide feedback on the answer, highlighting how well they've covered the three required elements (definitions, benefits, and code examples) for both decomposition and abstraction.
  *Student Response:*`
    }]
  },


  {
    id: "q2",
    text: ``,
    marks: 9,
    summary: "Data",
    initialCode: ``,
    prompt: ``,
    parts:[{
      id: "2.1",
      text: `A robotics student is programming a sensor to monitor temperature readings. The sensor needs to add two 8-bit values from different temperature probes.
      (a) While testing the sensor, these two 8-bit binary numbers were added:
      1 0 1 1 0 0 0 1
      1 0 1 0 1 1 0 0 +
      1 0 1 0 1 1 1 0 1
      (i) Explain what technical issue has occurred in this addition and why.`,
      marks: 3,
      summary: "Computational thinking",
      initialCode: ``,
      prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
    Question:
A robotics student is programming a sensor to monitor temperature readings. The sensor needs to add two 8-bit values from different temperature probes. While testing the sensor, these two 8-bit binary numbers were added:
10110001
10101100 +
10101101
Explain what technical issue has occurred in this addition and why.
Marks: 2 marks total

1 mark for identifying bit overflow condition
1 mark for explaining either:

The 9-bit result cannot be stored in 8 bits, OR
The sum exceeds the maximum 8-bit value of 255



Marking Instructions:

Check for clear identification of overflow condition
Verify explanation of why it's a problem
Accept either explanation for the second mark
Partial marks available

Final Scoring:
Overflow Identification: 1 mark
Explanation: 1 mark
Explanation to Student:
Provide feedback on the student's explanation, highlighting correct points and explaining any missing information.
**Student Response:**`
    },{
      id: "2.2",
      text: `(b) A digital thermostat needs to convert temperature readings between different number systems for various display modes.
      (i) Describe the process used to convert a binary temperature reading to its negative value using two's complement.`,
      marks: 3,
      summary: "Computational thinking",
      initialCode: ``,
      prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
    Question:
A digital thermostat needs to convert temperature readings between different number systems for various display modes. Describe the process used to convert a binary temperature reading to its negative value using two's complement.
Marks: 2 marks total
Award 2 marks for any ONE of these complete explanations:

Method 1: Invert all bits (1) and add one (1)
Method 2: Keep rightmost zeros and first 1 (1), invert remaining bits (1)
Method 3: Invert bits from left (1) until reaching rightmost 1 (excluding it) (1)

Marking Instructions:

Accept any ONE of the three valid methods
Award marks for each correct step in the chosen method
Both steps must be correctly described for full marks
Partial marks available for partial explanations

Final Scoring:
Step 1 of chosen method: 1 mark
Step 2 of chosen method: 1 mark
Explanation to Student:
Provide feedback on the student's explanation, highlighting correct points and explaining any missing steps.

**Student Response:**`
    },{
      id: "2.3",
      text: `(c) A game developer is optimising storage requirements for texture assets and needs to calculate minimum file sizes.
      (i) A game texture uses 15-bit color depth and contains 10 different colors. The texture dimensions are 1028 pixels wide by 640 pixels high. Complete the expression below to calculate the minimum file size in MiB (Mebibytes). You don't need to calculate the final result.
      Fill in the blank spaces in this expression:
            x     x 
      _______________
      1024  x     x `,
      marks: 4,
      summary: "Computational thinking",
      initialCode: ``,
      prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
     Question: A game developer is optimizing storage requirements for texture assets and needs to calculate minimum file sizes.
A game texture uses 15-bit color depth and contains 10 different colors. The texture dimensions are 1028 pixels wide by 640 pixels high. Complete the expression below to calculate the minimum file size in MiB (Mebibytes). You don't need to calculate the final result.

Fill in the blank spaces in this expression:

           x           x 
_______________
1024   x           x 

Marks: 4 marks total
1 mark for including 15 (color depth) in numerator
1 mark for including 1028 × 640 (image dimensions) in numerator
1 mark for including 1024 × 1024 (MiB conversion) in denominator
1 mark for including 8 (bits to bytes conversion) in denominator

Marking Instructions:
Check the Numerator: Verify if the student has included the correct values in the numerator:
- 1 mark for including 15 (the color depth)
- 1 mark for including 1028 × 640 (the image dimensions)

Check the Denominator: Verify if the student has included the correct values in the denominator:
- 1 mark for including 1024 × 1024 (for MiB conversion)
- 1 mark for including 8 (for bits to bytes conversion)

Note: The correct expression is:
1028 × 640 × 15
________________
1024 × 1024 × 8

Award full marks if the student's answer includes all the correct components in the right positions, even if multiplication symbols are missing or different symbols are used (e.g., ""X"" instead of ""×"").               Also accept anyother valid response.

Final Scoring:
Numerator - Color Depth: 1 mark for including 15
Numerator - Image Dimensions: 1 mark for including 1028 × 640
Denominator - MiB Conversion: 1 mark for including 1024 × 1024
Denominator - Bits to Bytes: 1 mark for including 8

Explanation to Student: Provide feedback on the student's expression, highlighting correct components and explaining any errors. If all components are correct but presented with different notation (e.g., using ""X"" instead of ""×""), still award full marks.

Very Important: When marking a student response like ""1028 X 640 X 15 / 1024 X 1024 X 8"" or similar where all components are correct but notation varies, award all 4 marks as this demonstrates understanding of the calculation requirements.

**Student Response:**`
    }]
 },


 {
  id: "q3",
  text: ``,
  marks: 6,
  summary: "Computers",
  initialCode: ``,
  prompt: ``,
  parts:[{
    id: "3.1",
    text: `A software development team is designing a new microprocessor based on classical computer architecture principles.
    (a) In their implementation of the von Neumann architecture, what two fundamental elements must be stored in RAM?`,
    marks: 2,
    summary: "Computational thinking",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
  Question:
A software development team is designing a new microprocessor based on classical computer architecture principles. In their implementation of the von Neumann architecture, what two fundamental elements must be stored in RAM?
Marks: 2 marks total

1 mark for identifying Data
1 mark for identifying Instructions

Marking Instructions:

Award one mark for each correct element identified
Both elements must be clearly stated
Accept variations in terminology (e.g., ""programs"" for instructions)
Partial marks available

Final Scoring:
Data Identification: 1 mark
Instructions Identification: 1 mark
Explanation to Student:
Provide feedback on the student's response, highlighting correct elements and explaining any missing components.

**Student Response:**`
  },{
    id: "3.2",
    text: `(b) As a software developer at a streaming service company, you're working on optimising video delivery to millions of users. Your team is discussing implementing new compression algorithms.
    (i) From the following list, identify two valid benefits of implementing data compression.
    Decreases time needed for data transmission
    Eliminates disk fragmentation issues
    Reduces storage space requirements
    Makes data more secure against cyber attacks
    Eliminates the need for error checking systems`,
    marks: 2,
    summary: "Computational thinking",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
  Question:
As a software developer at a streaming service company, you're working on optimizing video delivery to millions of users. Your team is discussing implementing new compression algorithms. From the following list, identify two valid benefits of implementing data compression.
Options:
A) Decreases time needed for data transmission
B) Eliminates disk fragmentation issues
C) Reduces storage space requirements
D) Makes data more secure against cyber attacks
E) Eliminates the need for error checking systems
Marks: 2 marks total

1 mark for identifying option A (Decreases time needed for data transmission)
1 mark for identifying option C (Reduces storage space requirements)

Marking Instructions:

Award one mark for each correct option selected
Only options A and C are correct
No partial marks for incorrect options
Maximum of two marks even if more options selected

Final Scoring:
First Correct Option: 1 mark
Second Correct Option: 1 mark
Explanation to Student:
Provide feedback on the student's selections, explaining why their choices were or weren't correct.
**Student Response:**`
  },{
    id: "3.3",
    text: `(c) A growing tech startup is setting up their new office network and needs to implement proper user management.
    (i) Explain one specific way the operating system enables an administrator to effectively manage multiple users.`,
    marks: 2,
    summary: "Computational thinking",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
  Question:
A growing tech startup is setting up their new office network and needs to implement proper user management. Explain one specific way the operating system enables an administrator to effectively manage multiple users.
Marks: 2 marks total

1 mark for identifying one management feature
1 mark for explaining its practical benefit

Example valid responses include:

User account creation/deletion (1) enabling secure multi-user access (1)
Permission management (1) ensuring secure file access control (1)
Resource quota management (1) allowing fair distribution of system resources (1)
Access control enforcement (1) maintaining system security through restricted permissions (1)

Marking Instructions:

Check for both feature identification and benefit explanation
Feature must be specific and clearly stated
Benefit must be logically connected to the feature
Partial marks available for incomplete answers

Final Scoring:
Management Feature: 1 mark
Practical Benefit: 1 mark
Explanation to Student:
Provide feedback on the student's explanation, highlighting correct points and explaining any missing components.
**Student Response:**`
  }]
},


{
  id: "q4",
  text: ``,
  marks: 6,
  summary: "Networks",
  initialCode: ``,
  prompt: ``,
  parts:[{
    id: "4.1",
    text: `TechStart, a growing software company, is setting up their office network. The IT team needs to implement security measures to protect their development work.
    (a) Explain how implementing a firewall would help protect their local area network (LAN)`,
    marks: 2,
    summary: "Computational thinking",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
  Question:
TechStart, a growing software company, is setting up their office network. The IT team needs to implement security measures to protect their development work. Explain how implementing a firewall would help protect their local area network (LAN).
Marks: 2 marks total

1 mark for explaining that the firewall monitors/inspects network traffic
1 mark for explaining that it uses predefined rules/policies to control data flow (including allowed/blocked IP addresses, protocols, or services)

Marking Instructions:

Check for both monitoring and control aspects
Both components must be clearly explained
Partial marks available for partial explanation
Accept reasonable variations in terminology

Final Scoring:
Traffic Monitoring: 1 mark
Rules Implementation: 1 mark
Explanation to Student:
Provide feedback on the student's explanation, highlighting correct points and explaining any missing components.
**Student Response:**`
  },{
    id: "4.2",
    text: `(b) An e-commerce platform experiences millions of transactions daily, with data packets traveling across multiple networks to reach customers worldwide.
    (i) Describe how routers ensure that each customer's transaction data reaches its intended destination.`,
    marks: 2,
    summary: "Computational thinking",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
   Question:
An e-commerce platform experiences millions of transactions daily, with data packets traveling across multiple networks to reach customers worldwide. Describe how routers ensure that each customer's transaction data reaches its intended destination.
Marks: 2 marks total
Award one mark each for any TWO of:

Examines the destination IP address in each transaction packet
Consults its routing table to determine optimal path
Forwards packets to the next appropriate router in the path
Selects routes based on current network congestion levels
Communicates with other routers to maintain updated traffic information

Marking Instructions:

Award one mark for each correct routing function described
Maximum of two marks even if more functions listed
Functions must be clearly described
Accept reasonable variations in wording

Final Scoring:
First Function: 1 mark
Second Function: 1 mark
Explanation to Student:
Provide feedback on the student's description, highlighting correct functions and explaining any missing or invalid points.
**Student Response:**`
  },{
    id: "4.3",
    text: `(c) A network engineer is creating documentation for a new team member about fundamental internet architecture.
    (i) Complete the diagram of the TCP/IP model by filling in the two missing layers:
  --------
      ▼
  --------
      ▼
    Internet
      ▼
    Link`,
    marks: 2,
    summary: "Computational thinking",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
    Question:
A network engineer is creating documentation for a new team member about fundamental internet architecture. Complete the diagram of the TCP/IP model by filling in the two missing layers:
________ ▼
________ ▼
Internet ▼
Link
Marks: 2 marks total

1 mark for correctly identifying ""Application"" as the top layer
1 mark for correctly identifying ""Transport"" as the second layer

Marking Instructions:

Award one mark for each correct layer
Layers must be in correct order
No partial marks for incorrect placement
Accept reasonable variations in terminology

Final Scoring:
Application Layer: 1 mark
Transport Layer: 1 mark
Explanation to Student:
Provide feedback on the student's response, highlighting correct layers and explaining any errors in placement or identification.
**Student Response:**`
  }]
},
{
  id: "q5",
  text: ``,
  marks: 6,
  summary: "Issues and Impact",
  initialCode: ``,
  prompt: ``,
  parts:[{
    id: "5.1",
    text: `SmartLearn, a new educational app, wants to collect student data to personalise learning experiences. Before implementing this feature, they need to inform users about their data practices.
    (a) Identify two pieces of essential information that SmartLearn must communicate to users when requesting consent for data collection.`,
    marks: 2,
    summary: "Computational thinking",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
    Question:
SmartLearn, a new educational app, wants to collect student data to personalize learning experiences. Before implementing this feature, they need to inform users about their data practices. Identify two pieces of essential information that SmartLearn must communicate to users when requesting consent for data collection.
Marks: 2 marks total
Award one mark for each piece of information from:

The specific purpose of data collection and processing
The right to withdraw consent at any time
Information about data sharing with third parties
Duration of data storage
Security measures for data protection
The voluntary nature of consent
Right to decline without service denial
Scope of data processing activities
Security measures implemented

Marking Instructions:

Award one mark for each distinct piece of information
Information must be clearly stated
Maximum of two marks even if more points listed
Accept reasonable variations in wording

Final Scoring:
First Information Piece: 1 mark
Second Information Piece: 1 mark
Explanation to Student:
Provide feedback on the student's response, highlighting correct information and explaining any invalid points.
**Student Response:**`
  },{
    id: "5.2",
    text: `(b) A major airline is considering implementing fully automated landing systems across their fleet.
    (i) While computer-assisted landings are common, explain one significant reason why computers cannot be solely responsible for all aircraft landings.`,
    marks: 2,
    summary: "Computational thinking",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
    Question:
A major airline is considering implementing fully automated landing systems across their fleet. While computer-assisted landings are common, explain one significant reason why computers cannot be solely responsible for all aircraft landings.
Marks: 2 marks total
Award 2 marks for any ONE complete linked explanation:
Technical limitations:

System may not handle unexpected variables (1)
Such as extreme weather conditions or emergency situations (1)

Hardware reliability:

Sensor malfunction possibility (1)
Leading to incorrect input data for landing calculations (1)

AI limitations:

Inability to make complex ethical decisions (1)
In scenarios requiring human judgment (1)

Marking Instructions:

Award one mark for identifying the limitation
Award one mark for explaining its specific safety consequence
Both components must be logically connected
Partial marks available for incomplete explanation

Final Scoring:
Limitation Identification: 1 mark
Safety Consequence: 1 mark
Explanation to Student:
Provide feedback on the student's explanation, highlighting correct points and explaining any missing components.
**Student Response:**`
  },{
    id: "5.3",
    text: `(c) During a cybersecurity audit at a multinational corporation, several computers were found to be infected with malware. The infection spread rapidly across the network without user interaction.
    (i) Describe one way that a computer worm can propagate from one machine to another.`,
    marks: 2,
    summary: "Computational thinking",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.
   Question:
During a cybersecurity audit at a multinational corporation, several computers were found to be infected with malware. The infection spread rapidly across the network without user interaction. Describe one way that a computer worm can propagate from one machine to another.
Marks: 2 marks total
Award 2 marks for any ONE complete linked explanation:
Self-replication:

Autonomous replication capability (1)
Utilizing network connections to spread (1)

Distribution method:

Email propagation mechanism (1)
Without requiring user execution (1)

Network exploitation:

Independent spread capability (1)
Without requiring host file attachment (1)

Marking Instructions:

Award one mark for identifying the propagation method
Award one mark for explaining its specific characteristic
Both components must be logically connected
Partial marks available for incomplete explanation

Final Scoring:
Method Identification: 1 mark
Characteristic Explanation: 1 mark
Explanation to Student:
Provide feedback on the student's description, highlighting correct points and explaining any missing components.
**Student Response:**`
  }]
},

];

export default questions;
